<template>
  <div class="calico-chip-page">
    <div class="calico-chip-container">
      <div class="calico-chip-row">
        <CalicoChip text="Chip 1" />
        <CalicoChip text="Chip 2" />
        <CalicoChip text="Chip 3" />
      </div>
      <div class="calico-chip-row">
        <CalicoChip text="Long text example that might break into multiple lines" />
      </div>
    </div>
  </div>
</template>
  
  <script>
  import CalicoChip from '@/components/calico/chip/index.vue';
  
  export default {
    name: 'CalicoChipPage',
    components: {
      CalicoChip,
    }
  };
  </script>
  
  <style lang="scss">
  .calico-chip-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .calico-chip-container {
      @include stack-space($space-large);
      @include inset-space($space-large);
      width: 100%;
      .calico-chip-row {
        @include inline-space($space-large);
        @include inset-space($space-large);
        display: flex;
        gap: $space-medium;
      }
    }
  }
  </style>
  